import React, { useEffect, useState } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
const _exp = /*#__PURE__*/() => ({
  duration
}) => duration;
const _exp2 = /*#__PURE__*/() => ({
  isRendered
}) => isRendered ? 1 : 0;
const ComponentWrapper = /*#__PURE__*/styled('div')({
  name: "ComponentWrapper",
  class: "c1c6wavq",
  propsAsIs: false,
  vars: {
    "c1c6wavq-0": [_exp(), "s"],
    "c1c6wavq-1": [_exp2()]
  }
});
interface Props {
  children: React.ReactNode;
  skip?: boolean;
  delay?: number;
  duration?: number;
  isVisible?: boolean;
  ignorePosition?: boolean;
  className?: string;
}
const OpacityAnimation = ({
  children,
  skip = false,
  duration = 0.3,
  ignorePosition = false,
  isVisible = true,
  delay = 0,
  className
}: Props) => {
  const [isRendered, setIsRendered] = useState(!isVisible);
  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setIsRendered(isVisible);
    }, delay);
    return () => {
      window.clearTimeout(timeout);
    };
  }, [isVisible, delay]);
  if (skip) return <div>{children}</div>;
  return <ComponentWrapper isRendered={isRendered} duration={duration} className={cx(className, !ignorePosition && `withPosition--${isRendered ? 'isRendered' : 'isNotRendered'}`)}>
      {children}
    </ComponentWrapper>;
};
export default React.memo(OpacityAnimation);

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");